import { Select as MantineSelect } from '@mantine/core'
import { UseFormRegisterReturn } from 'react-hook-form'

export interface SelectOption {
  value: string
  label: string
  disabled?: boolean
}

interface SelectProps {
  label: string
  placeholder?: string
  required?: boolean
  error?: string
  helperText?: string
  className?: string
  disabled?: boolean
  data: SelectOption[]
  register?: UseFormRegisterReturn
  value?: string
  onChange?: (value: string | null) => void
  searchable?: boolean
  clearable?: boolean
  formValue?: string // For controlled component with react-hook-form
}

export function Select({
  label,
  placeholder,
  required = false,
  error,
  helperText,
  className = '',
  disabled = false,
  data,
  register,
  value,
  onChange,
  searchable = false,
  clearable = false,
  formValue,
}: SelectProps) {
  const selectProps = register
    ? {
        name: register.name,
        ref: register.ref,
        value: formValue,
        onChange: (value: string | null) => {
          register.onChange({ target: { value: value || '' } })
        },
      }
    : {
        value,
        onChange,
      }

  return (
    <div className={`space-y-1 ${className}`}>
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <MantineSelect
        {...selectProps}
        placeholder={placeholder}
        disabled={disabled}
        data={data}
        error={error}
        description={helperText}
        radius="md"
        size="md"
        className="w-full"
        searchable={searchable}
        clearable={clearable}
        styles={{
          input: {
            backgroundColor: '#F5F5F7',
            border: 'none',
          },
          error: {
            fontSize: 10,
          },
        }}
      />
    </div>
  )
}
